import { UserMenu } from "@hm/fundamental"
import { useCarbonBankClient } from "@shared/api/client"
import React from "react"

import { useLanguageSettings, useUserMenuItems } from "../model"
import { NotificationSettings } from "./notification-settings"
import { UserMenuFooter } from "./user-menu-footer"

export const UserMenuFeature: React.FC = () => {
	const apiClient = useCarbonBankClient()

	const { availableLanguages, selectedLocale, handleLanguageChanged } =
		useLanguageSettings()

	const { loggedInItems, loggedOutItems, isAuthenticated } = useUserMenuItems(
		{
			apiClient,
			availableLanguages,
			selectedLocale,
			handleLanguageChanged,
			notificationSettingsView: (
				<NotificationSettings apiClient={apiClient} />
			),
		},
	)

	return (
		<UserMenu
			data-cy="user-menu"
			loggedIn={isAuthenticated}
			items={isAuthenticated ? loggedInItems : loggedOutItems}
			footer={<UserMenuFooter />}
		/>
	)
}
